import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { BasicModal } from '@app/components/Modal';
import documentAuthService from '@app/libs/auth/documentAuthService';
import embeddedService from '@app/libs/embedded/embeddedService';
import { modalClose } from '@app/store/modal/actions';
import { fetchParticipantStatus } from '@app/store/participant/actions';

interface ParticipantProcessingModalProps {
  documentId: string;
  participantId: string;
}

export default function ParticipantProcessingModal({
  documentId,
  participantId,
}: ParticipantProcessingModalProps) {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleCancel = useCallback(() => {
    if (!documentAuthService.isLinkUser()) {
      history.push('/');
    }

    dispatch(modalClose());
  }, [dispatch, history]);

  const handleClose = useCallback(() => {
    dispatch(
      fetchParticipantStatus({
        participantId,
        documentId,
        redirect: true,
      })
    );

    dispatch(modalClose());
  }, [dispatch, documentId, participantId]);

  let cancelText = '';
  if (!embeddedService.isEmbedded) {
    cancelText = documentAuthService.isLinkUser() ? '닫기' : '홈으로';
  }

  return (
    <BasicModal
      cancelText={cancelText}
      closeText="다시 시도하기"
      content={'현재 문서가 처리중입니다.\n잠시 후 다시 시도해 주세요.'}
      title="문서 처리중"
      onCancel={handleCancel}
      onClose={handleClose}
    />
  );
}
